import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';

import { UserService } from './user.service';

/**
 * Guard for masterclass availability
 */
export const masterclassAvailableGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const userService = inject(UserService);
  let available = userService.isMasterclassAvailable();
  if (available == null) {
    available = await lastValueFrom(userService.checkFirstTimeIfMasterclassAvailable());
  }
  if (!available) {
    return router.parseUrl('overview');
  }

  return true;
};
